import * as ActionTypes from '../Actions/EnumTypes/ActionEnumTypes';
import {FleetAction} from '../Actions/Models/FleetActionModel';
import * as Types from '../../Models/FleetModel';
import {DEFAULT_PAGE_SIZE_FOR_LIST_VIEW, START_FROM} from "../../constants";

export type State = Types.FleetStore;
export const initialState: State = {
    fleets: {
      results: [],
      totalCount: null,
      first: null,
      max: null
    },
    params: new URLSearchParams(`?max=${DEFAULT_PAGE_SIZE_FOR_LIST_VIEW}&first=${START_FROM}`),
    fleetsFiltered: null,
    activeFleet: null,
    activeFleetRowId: null,
    manageFleetCars: [],
    manageFleetCarsIds: [],
    cachedChangedValues: null
};

export function fleetReducer(state: State = initialState, action: FleetAction): State {
    switch (action.type) {
        case ActionTypes.FLEET.GET_USER_FLEET:
            return {
                ...state,
                fleets: action.payload.userFleetsResponse
            };
        case ActionTypes.FLEET.GET_USER_FLEET_FILTERED:
            return {
                ...state,
                fleetsFiltered: action.payload.userFleetsResponse
            };
        case ActionTypes.FLEET.RESET_FLEET_FILTERED_DATA:
            return {
                ...state,
                fleetsFiltered: initialState.fleetsFiltered,
                params: initialState.params
            };
        case ActionTypes.FLEET.MANAGE_FLEET_CARS:
            const { type, car } = action.payload;
            const manageFleetCarsClone = [...state.manageFleetCars];
            const manageFleetCarsIdsClone = [...state.manageFleetCarsIds];
            if (type === 'ADD') {
                const checkIfContains = manageFleetCarsClone.findIndex(e => e.id === car.id);
                if (checkIfContains === -1) {
                    manageFleetCarsClone.push(car);
                    manageFleetCarsIdsClone.push(car.id);
                }
            } else {
                const carIdToRemove = manageFleetCarsClone.findIndex(carDto => {
                    return carDto.id === car.id;
                });
                manageFleetCarsIdsClone.splice(carIdToRemove, 1);
                manageFleetCarsClone.splice(carIdToRemove, 1);
            }
            return {
                ...state,
                manageFleetCars: manageFleetCarsClone,
                manageFleetCarsIds: manageFleetCarsIdsClone,
                cachedChangedValues: {
                  ...(state.cachedChangedValues || {}),
                  carIds: manageFleetCarsClone
                }
            };

        case ActionTypes.FLEET.RESET_FLEET_CARS:
            return {
                ...state,
                manageFleetCars: [],
                manageFleetCarsIds: []
            };
        case ActionTypes.FLEET.SET_ACTIVE_FLEET:
            return {
                ...state,
                activeFleet: action.payload.activeFleet,
                manageFleetCars: action.payload.activeFleet ? [...action.payload.activeFleet.cars] : [],
                manageFleetCarsIds: action.payload.activeFleet ? [...action.payload.activeFleet.cars.map((e, i) => e.id)] : []
            };
        case ActionTypes.FLEET.SET_ACTIVE_ROW_ID:
            return {
                ...state,
                activeFleetRowId: action.payload.activeFleetRowId
            };
        case ActionTypes.FLEET.SET_PARAMS:
            return {
                ...state,
                params: action.payload.params
            };
        case ActionTypes.FLEET.CACHE_FORM_VALUES:
            return {
                ...state,
              cachedChangedValues: action.payload.cachedChangedValues
            };
        case ActionTypes.FLEET.CREATE_FLEET:
        case ActionTypes.FLEET.DELETE_CAR_FROM_FLEET:
        case ActionTypes.FLEET.UPDATE_FLEET_CARS:
        default:
            return {
                ...state
            };
    }
}



// WEBPACK FOOTER //
// ./src/Redux/Reducers/FleetReducer.ts